import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import LinearGradient from 'react-native-linear-gradient';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

export const ContentHeader = styled.View`
  margin-bottom: ${RFValue(12)}px;
  padding: 0 24px;
`;

export const Form = styled.View`

`;

export const Hero = styled.View`
  margin: 0 24px;
    margin-bottom: ${RFValue(12)}px;
`;

export const FormSurface = styled.View`
  padding: ${RFValue(4)}px;
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
`;

export const UnitsList = styled.View`
  margin: 0 -24px;
`;

export const Section = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(18)}px;
  margin-bottom: ${RFValue(6)}px;

  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const StoreList = styled.View``;

export const FormFooter = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  margin-top: ${RFValue(12)}px;
`;

export const FilterPill = styled.TouchableOpacity`
  width: 100%;
`;

export const FilterGradient = styled(LinearGradient)`
    flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(10)}px ${RFValue(12)}px;
  border-radius: ${RFValue(12)}px;
  gap:${RFValue(12)}px;
`;

export const FilterPillText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
`;

export const FilterPillDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(10)}px;
`;

export const FilterIconContainer = styled.View`
  width: ${RFValue(32)}px;
  background-color: rgba(255,255,255,0.3);
  border-radius: ${RFValue(12)}px;
  justify-content: center;
  align-items: center;
  height: ${RFValue(32)}px;
`;
export const FilterIcon = styled(FontAwesome5)`
 color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(14)}px;
`;

export const FilterInfos = styled.View`
  flex-direction: column;
`;

export const FilterBadge = styled.View`
  width: ${RFValue(20)}px;
  height: ${RFValue(20)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.primary_light};
  border-radius: ${RFValue(20)}px;
`;

export const FilterBadgeText = styled.Text`
  color: ${({theme}) => theme.colors.primary};
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(10)}px;
`;

export const LoadingList = styled.View`
  align-self: center;
  margin-top: ${RFValue(12)}px;
  padding-bottom: ${getBottomSpace() ? getBottomSpace() - 12 : 0}px;
`;

export const NotFoundContainer = styled.View`
  position: absolute;
  width: 100%;
  margin: 0 24px;
  top: ${RFPercentage(10)}px;
`;

export const LoadingShimmerContainer = styled.View`
  flex: 1;
  gap:${RFValue(12)}px;

`;
